import React from 'react'
import { useParams } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import { useAppConfig } from '_application'
import { useIntl } from 'react-intl'
import { IKUICore } from '@indykiteone/jarvis-sdk-web'
import Header from 'components/indy/shared/logged/header'
import { defaultLoginBackground } from '_resources'
import LoginTitle from '_components/login-title'
import LoginRegister from '_uikit/login-register'
import { LoginContainer } from '_themes/default/components/styled/login-register'
import { useSetThemeSettings } from '_application'
import { useThemeSettings } from '_application'
import styled from '@emotion/styled'

const Video = styled.video`
  width: 100%;
  height: 100%;
  position: absolute;
  object-fit: cover;
`

const Index = () => {
  const intl = useIntl()
  const config = useAppConfig()
  const { referenceId } = useParams()
  useSetThemeSettings({ hasAlternativeBgc: true })
  const themeSettings = useThemeSettings()

  const description = intl.formatMessage({
    id: 'setnewpassword.newpassword.description',
  })

  const backgroundImage = config?.backgroundImages?.login
  const isBackgroundVideo = backgroundImage?.type === 'video'
  const backgroundUrl = backgroundImage?.value || defaultLoginBackground
  IKUICore.renderSetNewPasswordForm({
    labels: {
      newPassword: `${intl.formatMessage({
        id: 'setnewpassword.newpassword.label',
      })}`,
      confirmNewPassword: `${intl.formatMessage({
        id: 'setnewpassword.newpasswordconfirm.label',
      })}`,
      submitButton: `${intl.formatMessage({
        id: 'setnewpassword.newpasswordconfirm.button',
      })}`,
    },
    renderElementSelector: '#set-new-password-container',
    token: referenceId,
  })
  return (
    <>
      <Header />
      <LoginRegister themeSettings={themeSettings}>
        <LoginContainer>
          <Row className="login-container">
            <Col className="login-col">
              <h2 className="login-title">
                {intl.formatMessage({ id: 'setnewpassword.newpassword.title' })}
              </h2>
              <div id="set-new-password-container" />
            </Col>
            <Col className="image-col">
              {isBackgroundVideo ? (
                <Video
                  className="background"
                  width="100%"
                  height="100%"
                  src={backgroundUrl}
                  playsinline
                  autoPlay
                  muted
                  loop
                />
              ) : (
                <img className="thumbnail" src={backgroundUrl} alt="" />
              )}
              <LoginTitle>{description}</LoginTitle>
            </Col>
          </Row>
        </LoginContainer>
      </LoginRegister>
    </>
  )
}

export default Index
